import { useCallback } from 'react';
import { ImageCrop } from '../types/chatbotConfig.types';
import { config } from '../lib/config';
import { useConfig } from './queries/useConfig';

export type AssetUrlBuilder = (
  imageId?: string,
  crop?: ImageCrop,
  variant?: number,
  format?: string
) => string | undefined;

export const useAssetUrl = (): AssetUrlBuilder => {
  const { data: chatbotConfig } = useConfig();
  const baseUrl = config.cloudflareImagesBaseUrl;
  const organizationId = chatbotConfig?.organizationId;

  return useCallback<AssetUrlBuilder>(
    (imageId?: string, crop?: ImageCrop, variant: number = 1366, format?: string) => {
      if (!imageId || !organizationId) {
        return undefined;
      }

      const params = {
        width: variant,
        height: variant,
        ...(crop
          ? {
              'trim.width': crop.width,
              'trim.height': crop.height,
              'trim.left': crop.x,
              'trim.top': crop.y,
            }
          : {}),
        format,
      };

      const paramsString = Object.entries(params)
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join(',');

      return `${baseUrl}/${organizationId}/${imageId}/${paramsString}`;
    },
    [baseUrl, organizationId]
  );
};
